import {
  TimeLimitText as TimeLimitTextComponent,
  useTimeLeftToEditClone,
} from '@carboncopyco/components';
import { useGetRecordingQuery } from '@carboncopyco/data';
import type { IRecording } from '@carboncopyco/types';
import { Button } from '@carboncopyco/ui';
import { KnowledgeBaseLinksEnum } from '../../../shared/enums/KnowledgeBaseLinksEnum';
import { useFlagsFallback } from '../../hooks/useFlagsFallback';
import { useUser } from '../../store/context';

const TimeLimitTextContainer = ({
  updateCloneTimeLimit,
  clone,
}: {
  updateCloneTimeLimit: string;
  clone: IRecording;
}) => {
  const timeLeftToEditClone = useTimeLeftToEditClone(
    clone,
    Number(updateCloneTimeLimit)
  );

  const handleLearnMore = () => {
    window.dsDesktop?.shellOpenExternal(
      KnowledgeBaseLinksEnum.ContinueCloningPage
    );
  };

  return (
    <TimeLimitTextComponent
      timeLimit={`${timeLeftToEditClone} days`}
      learnMore={
        <Button
          className="text-sm font-ds-inter font-ds-medium text-ds-primary"
          onClick={handleLearnMore}
        >
          Learn more
        </Button>
      }
    />
  );
};

const StartRecordingTimeLeftText = ({
  cloneId,
  className,
}: {
  cloneId?: string;
  className?: string;
}) => {
  const { activeOrganization } = useUser();
  const organizationId = activeOrganization?.id.toString();
  const { data: clone } = useGetRecordingQuery(
    {
      organizationId: activeOrganization?.id.toString(),
      id: (cloneId || '').toString(),
    },
    {
      skip: !cloneId || !organizationId,
    }
  );
  const { platformUpdateCloneTimeLimit: updateCloneTimeLimit } =
    useFlagsFallback();

  return updateCloneTimeLimit && clone ? (
    <div className={className}>
      <TimeLimitTextContainer
        updateCloneTimeLimit={updateCloneTimeLimit}
        clone={clone}
      />
    </div>
  ) : null;
};

export default StartRecordingTimeLeftText;
